import {ReactNode} from 'react';

import {section, sectionInner, sectionTitle} from '../lib/styles';

export const Section = ({children, className = '', title}: {children: ReactNode; className?: string; title?: string}) => (
  <section className={`${section} ${className}`}>
    <div className={sectionInner}>
      {title ? <h2 className={sectionTitle}>{title}</h2> : null}
      {children}
    </div>
  </section>
);
